import { createFileRoute } from '@tanstack/react-router';

import { PrivacyPolicy } from '@/features/legal/PrivacyPolicy';

/** `/privacy` —— 隱私權政策（公開頁，不需登入）。 */
export const Route = createFileRoute('/privacy')({
  component: PrivacyPolicy,
});
